import { useState } from 'react';
import { Image } from 'react-bootstrap';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

import AppLogo from '@assetsApp/app_logo.svg';
import { BasicModal, Button, CustomIcon } from '@componentsApp/common/index';
import { PERMISSIONS, ROUTES } from '@constantsApp/index';
import { useLocalStorage } from '@hooksApp/index';
import { tnl } from '@i18nApp/i18n';
import { updateUserStorage } from '@routesApp/PrivateRoute/PrivateRouteRequest';
import { sidebarItemsRender } from '@utilsApp/index';
import './sidebar.scss';

const Sidebar = ({ collapse }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData, userPermissions } = useLocalStorage();
  const [showModal, setShowModal] = useState('none');

  const viewOperation = [
    {
      title: tnl('labels.operation_cuc'),
      icon: 'journalMedical',
      isVisible: userPermissions.includes(
        PERMISSIONS.PATIENT_MANAGEMENT.CAN_VIEW_OPERATION_CUC
      ),
      tenant: 'cuc'
    },
    {
      title: tnl('labels.operation_csb'),
      icon: 'journalMedical',
      isVisible: userPermissions.includes(
        PERMISSIONS.PATIENT_MANAGEMENT.CAN_VIEW_OPERATION_CSB
      ),
      tenant: 'csb'
    },
    {
      title: tnl('labels.operation_cec'),
      icon: 'journalMedical',
      isVisible: userPermissions.includes(
        PERMISSIONS.PATIENT_MANAGEMENT.CAN_VIEW_OPERATION_CEC
      ),
      tenant: 'cec'
    },
    {
      title: tnl('labels.operation_iberoamerican'),
      icon: 'journalMedical',
      isVisible: userPermissions.includes(
        PERMISSIONS.PATIENT_MANAGEMENT.CAN_VIEW_OPERATION_IBEROAMERICAN
      ),
      tenant: 'iberoamerica'
    }
  ].filter((operation) => operation.isVisible);

  const releaseChanges = [
    '1.2 Mostrar campos de la modal de OM como columnas en la tabla (autorizacion/(edicion))',
    '1.3 añadir las siguientes opciones en la modal de autorizaciones (comentario1)',
    '1.4 Añadir filtro por pacientes que tienen novedad en autorizacion. Visual de gestion de pacientes',
    '1.5. Incluir columna con prestador de autorización en todos los data table.',
    '1.6. Mostrar la alerta de autorizaciones al hacer la programación de los pacientes que tengan novedad.',
    '1.7. Poder descartar ordenes médicas desde visual de Autorizaciones/OM(edicion) __Añadir btn de borrar de la otra modal__',
    'Se ajusta la funcion de obtainPremedications para que acepte array de ids o array de objetos con el pk'
  ];

  const availableModals = {
    deployModal: (
      <BasicModal
        title="buttons.releases"
        body={
          <>
            <p>
              <b>Cambios en la versión</b>
            </p>
            <ul>
              {releaseChanges.map((change, index) => (
                <li key={`change_${index}`}>{change}</li>
              ))}
            </ul>
            <p className="fw-bold">
              {`Front-${tnl('develop')}: 2026-10-01`}
              <span className="fw-normal">1.7.4</span>
            </p>
          </>
        }
        onHide={() => setShowModal('none')}
      />
    )
  };

  return (
    <>
      {showModal !== 'none' && availableModals[showModal]}
      <div
        className={`sidebar ${collapse ? 'sidebar_hidden' : 'sidebar_visible'}`}
      >
        <div className="sidebar_content">
          <NavLink to={ROUTES.PLATFORM} className="sidebar_logo_container">
            <Image src={AppLogo} alt="app_logo" className="sidebar_logo" />
          </NavLink>
          {/* <p className="sidebar_domain mb-3">{userData.domain_name}</p> */}
          {userData.is_superuser && (
            <Button
              variant="link"
              iconName="releases"
              title="buttons.releases"
              onClick={() => setShowModal('deployModal')}
            />
          )}
          {sidebarItemsRender(
            userData.sidebarData,
            location,
            viewOperation.length > 0 ? viewOperation[0] : null,
            userData
          )}
          <div className="sidebar_userOptions">
            <CustomIcon name="user" color="white" size="LG" />
            <div className="sidebar_userLogged">
              <div className="d-flex gap-2 align-items-center">
                {userData?.first_name ?? ' - '}
                <div
                  title={tnl('buttons.update_user')}
                  onClick={updateUserStorage}
                >
                  <CustomIcon
                    name="reload"
                    color="white"
                    size="XS"
                    className="cursor-pointer"
                  />
                </div>
              </div>
              <Button
                variant="link"
                iconName="logout"
                text="buttons.logout"
                onClick={() => {
                  localStorage.clear();
                  navigate(ROUTES.LOGIN);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
